import 'lazysizes';

import { HelperInitializer } from './Helper/HelperInitializer';
import { MenuInitializer } from './Menu/MenuInitializer';
import { NumberInitializer } from './Number/NumberInitializer';
import { SliderInitializer } from './Slider/SliderInitializer';
import { EventSearchInitializer } from './Event/EventSearchInitializer';
import { SearchInitializer } from './Search/SearchInitializer';
import { Form } from './Form/Form';
import { ProductScrollContextInitializer } from './Scrollytelling/Scrollytelling';
import { AnimationFactoryInitializer } from './Animation/Animation';
import { HistoryInitializer } from './History/HistoryInitializer';
import { NewsSearchInitializer } from './News/NewsSearchInitializer';
import { PopupInitializer } from './Popup/Popup';
import { FlyoutInitializer } from './Flyout/FlyoutInitializer';
import { AccordionInitializer } from './Accordion/AccordionInitializer';
import { HeroSliderInitializer } from './Slider/HeroSliderInitializer';
import { TableScrollInitializer } from './Products/TableScrollInitializer';
import { SecondarySliderInitializer } from './Slider/SecondarySliderInitializer';
import { GalleryInitializer } from './Gallery/GalleryInitializer';
import { FocusAreaCropInitializer } from './FocusArea/FocusAreaCropInitializer';
import { ModalInitializer } from './Modal/ModalInitializer';
import { BackOnReferer } from './BackOnReferer/BackOnReferer';
import { TilesInitializer } from './Tiles/TilesInitializer';
import { ScrollCTAInitializer } from './Products/ScrollCTAInitializer';
import { AddressMapLoader } from './Map/AddressMapLoader';
import { HeroVideoInitializer } from './Video/HeroVideoInitializer';
/** init the controllers **/

document.addEventListener('DOMContentLoaded', () => {
	new HelperInitializer().init();
	new MenuInitializer().init();
	new SliderInitializer().init();
	new NumberInitializer().init();
	new EventSearchInitializer().init();
	new SearchInitializer().init();
	new Form().init();
	new ProductScrollContextInitializer();
	new AnimationFactoryInitializer();
	new NewsSearchInitializer().init();
	new GalleryInitializer().init();
	new ModalInitializer().init();
	new BackOnReferer().init();
	PopupInitializer.init();
	new FlyoutInitializer().init();
	new AccordionInitializer().init();
	new TableScrollInitializer().init();
	new ScrollCTAInitializer().init();
	new FocusAreaCropInitializer().init();
	new TilesInitializer().init();
	new AddressMapLoader().init();
	new HeroVideoInitializer().init();
});
new HeroSliderInitializer().init();
new SecondarySliderInitializer().init();
new HistoryInitializer().init();
